import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Typography, Card, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { TopNavigation } from '@/components/TopNavigation';
import { supplyChainMapPoints } from '@/config/supplyChainMapPoints';
// import './SystemPage.css';

const { Title, Text } = Typography;

export default function SupplyChainSubPage() {
  const navigate = useNavigate();
  const { systemId } = useParams<{ systemId: string }>();
  const point = supplyChainMapPoints.find((p) => p.id === systemId);

  if (!point) {
    return (
      <div className="system-page">
        <TopNavigation />
        <div className="system-page-container">
          <Button type="text" icon={<ArrowLeftOutlined />} onClick={() => navigate('/enterprise/supply-chain')}>
            返回供应链地图
          </Button>
          <Title level={4}>未找到该系统</Title>
        </div>
      </div>
    );
  }

  return (
    <div className="system-page">
      <TopNavigation />
      <div className="system-page-container">
        <div className="system-page-header">
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/enterprise/supply-chain')}
            style={{ marginBottom: 16 }}
          >
            返回供应链地图
          </Button>
          <Space align="center" size="large">
            <div className="system-icon" style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' }}>
              <span style={{ fontSize: 24, color: '#fff' }}>◆</span>
            </div>
            <div>
              <Title level={2} style={{ margin: 0, color: '#1e293b' }}>
                {point.name}
              </Title>
              <Text type="secondary">{point.description}</Text>
            </div>
          </Space>
        </div>
        <div className="system-page-content">
          <Card>
            <p>此处为 {point.name} 功能页面，可根据业务需要接入具体功能模块。</p>
          </Card>
        </div>
      </div>
    </div>
  );
}
